module.exports = __webpack_public_path__ + "assets/img/f-c-2.41e7517b.png";